import { Global, LineOverSchedule } from '../../model';
import { deepmerge } from 'utilities/merge';
const defaultTaskable = {
  location_name: ''
}
export class NewValuesTooltipScheduleTaskable {
  static set(taskable = {}, schedule: LineOverSchedule): any{
    taskable = deepmerge(defaultTaskable, taskable);
    let taskData = schedule.taskData();
    if(taskData.taskable_type && taskData.taskable_id){
      if(taskData.taskable_type == 'Tasks::Casting'){
        this.setCasting(taskable, taskData);
      } else if(taskData.taskable_type == 'Tasks::Delivery') {
        this.setDelivery(taskable, taskData);
      }
    }
    return taskable;
  }
  private static setCasting(taskable, taskData){
  }
  private static setDelivery(taskable, taskData){
    let taskableData = Global.getTaskableData(taskData.taskable_id, taskData.taskable_type);
    let locationName = '';
    if(taskableData.location_id){
      locationName = Global.getLocationData(taskableData.location_id).name;
    }
    taskable['location_name'] = locationName;
  }
}
